var map = {
	"./colfactura/Icono almacenamiento.svg": 739,
	"./colnomina/Icono almacenamiento.svg": 740,
	"./firmamail/Icono almacenamiento.svg": 741,
	"./firmaya/Icono almacenamiento.svg": 742
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 738;